// admin-nav.ts — (tf3-43; planning 10-21 18:20) the admin sidebar, pure.
/** A nav row is lit on its pages, but not under a path that has a row of its own (Slates vs Slate learning). */
export const navLit = (isActive: boolean, pathname: string, notUnder?: string) =>
  isActive && !(notUnder && (pathname === notUnder || pathname.startsWith(`${notUnder}/`)));
